import { Set } from 'immutable';

import type { ReduxAction } from 'app/redux/types';

import { ConflictCase } from '../constants';
import type { InsertInBetSlip, InsertInQueueForAdd } from './entries';

// ---

type InsertInQueueForAddPayload = InsertInQueueForAdd['payload'];
type InsertInBetSlipPayload = InsertInBetSlip['payload'];

// ---

export const RESOLVE_BY_CANCEL_INSERT = 'BET_SLIP:RESOLVE_BY_CANCEL_INSERT';

export type ResolveByCancelInsert = ReduxAction<typeof RESOLVE_BY_CANCEL_INSERT, {
  betId: number;
}>;

export const resolveByCancelInsert = (betId: number): ResolveByCancelInsert => ({
  type: RESOLVE_BY_CANCEL_INSERT,
  payload: { betId },
});

// ---

export const RESOLVE_BY_REPLACE_ENTRIES = 'BET_SLIP:RESOLVE_BY_REPLACE_ENTRIES';

export type ResolveByReplaceEntries = ReduxAction<typeof RESOLVE_BY_REPLACE_ENTRIES, {
  by: InsertInQueueForAddPayload;
}>;

export const resolveByReplaceEntries = (
  by: InsertInQueueForAddPayload,
): ResolveByReplaceEntries => ({
  type: RESOLVE_BY_REPLACE_ENTRIES,
  payload: { by },
});

// ---

export const RESOLVE_BY_ACCEPT_AVAILABILITY = 'BET_SLIP:RESOLVE_BY_ACCEPT_AVAILABILITY';

export type ResolveByAcceptAvailability = ReduxAction<typeof RESOLVE_BY_ACCEPT_AVAILABILITY, {
  entry: InsertInBetSlipPayload;
}>;

export const resolveByAcceptAvailability = (
  entry: InsertInBetSlipPayload,
): ResolveByAcceptAvailability => ({
  type: RESOLVE_BY_ACCEPT_AVAILABILITY,
  payload: { entry },
});

// ---

export const SETUP_CONFLICT = 'BET_SLIP:SETUP_CONFLICT';

export type ResolveActions =
  | ResolveByCancelInsert
  | ResolveByReplaceEntries
  | ResolveByAcceptAvailability;

export type SetupConflictPayload = {
  case: ConflictCase | null;
  entries: InsertInQueueForAddPayload[];
  highlightEntryIds?: Set<number>;
  actions: ResolveActions[];
};

export type SetupConflict = ReduxAction<typeof SETUP_CONFLICT, SetupConflictPayload>;

export const setupConflict = (payload: SetupConflictPayload): SetupConflict => ({
  type: SETUP_CONFLICT,
  payload,
});

// ---

export const REMOVE_CONFLICTED_ENTRIES = 'BET_SLIP:REMOVE_CONFLICTED_ENTRIES';

export type RemoveConflictedEntries = ReduxAction<typeof REMOVE_CONFLICTED_ENTRIES, {
  entryIds: number[];
}>;

export const removeConflictedEntries = (entryIds: number[]): RemoveConflictedEntries => ({
  type: REMOVE_CONFLICTED_ENTRIES,
  payload: { entryIds },
});


export const SET_LAST_TRIGGERED_TIME = 'CONFLICT:SET_LAST_TRIGGERED_TIME';

export type SetLastTriggeredTime = ReduxAction<typeof SET_LAST_TRIGGERED_TIME, {
  lastTriggeredTime: number;
}>;

export const setLastTriggeredTime = (lastTriggeredTime: number): SetLastTriggeredTime => ({
  type: SET_LAST_TRIGGERED_TIME,
  payload: { lastTriggeredTime },
});
